export enum VatRateType {
    VAT_0 = 'VAT_0',
    VAT_5 = 'VAT_5',
    VAT_8 = 'VAT_8',
    VAT_23 = 'VAT_23',
    RELEASED = 'RELEASED',
    NOT_SUBJECT = 'NOT_SUBJECT',
}

export enum VatReleaseReason {
    ART_113_1_9 = 'ART_113_1_9',
    ART_82_3 = 'ART_82_3',
    ART_43_1 = 'ART_43_1',
    CUSTOM = 'CUSTOM',
}

export type SettlementVatRatesSettingsDto = {
    mealVatRateType: VatRateType;
    mealVatReleaseReason: VatReleaseReason | null;
    mealCustomVatReleaseReason: string | null;
    stayVatRateType: VatRateType;
    stayVatReleaseReason: VatReleaseReason | null;
    stayCustomVatReleaseReason: string | null;
    starterKitVatRateType: VatRateType;
    starterKitVatReleaseReason: VatReleaseReason | null;
    starterKitCustomVatReleaseReason: string | null;
};

export type UpdateSettlementVatRatesSettingsDto = Pick<
    SettlementVatRatesSettingsDto,
    'mealVatRateType' | 'starterKitVatRateType' | 'stayVatRateType'
> &
    Partial<
        Pick<
            SettlementVatRatesSettingsDto,
            | 'mealVatReleaseReason'
            | 'mealCustomVatReleaseReason'
            | 'stayVatReleaseReason'
            | 'stayCustomVatReleaseReason'
            | 'starterKitVatReleaseReason'
            | 'starterKitCustomVatReleaseReason'
        >
    >;
